import { useCallback, useMemo } from 'react';

import { useNavigate } from '@interlayer/js/app/hooks/navigate/useNavigate/useNavigate';
import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { getRefereeCookie } from '@interlayer/js/app/utils/referrer.util';

export const useNavigateToSlotPage = () => {
    const navigate = useNavigate();
    const { config: { afterRegistrationAction, btagsLinkConfig } } = useRegistrationSelector();
    const [dTagSlotWelcomePage = '/slot-welcome'] = useDynamicTags([DYNAMIC_TAG_NAMES.slotWelcomePage]);
    const btagLink = useMemo(() => {
        const { custom19: bTagCookie } = getRefereeCookie() as { custom19: string };

        if (!bTagCookie || !btagsLinkConfig?.length) {
            return '';
        }

        return btagsLinkConfig.find((config) => config?.btag === bTagCookie)?.link || '';
    }, [btagsLinkConfig]);

    return useCallback(() => {
        navigate(btagLink || afterRegistrationAction || dTagSlotWelcomePage);
    }, [afterRegistrationAction, btagLink, dTagSlotWelcomePage, navigate]);
};
